import { Entity, Column, PrimaryGeneratedColumn, ManyToOne, Unique, JoinColumn } from 'typeorm'

import Audience from './Audience'

import { RespondentSource, DemographicKey } from '../entityTypes'

@Entity('audience_demographics')
@Unique("audience_demographic_unique", ["key", "audience"])
export default class AudienceDemographic {
  @PrimaryGeneratedColumn('uuid')
  id!: string

  @Column({ nullable: true, type: 'enum', enum: RespondentSource })
  source!: RespondentSource

  @Column({ nullable: true, type: 'enum', enum: DemographicKey })
  key!: DemographicKey

  @Column({ type: 'text', array: true })
  codes!: string[]

  @ManyToOne(type => Audience, audience => audience)
  @JoinColumn({ name: "audience_id" })
  audience!: Audience
}
